import { ApiEnvironment } from '../../models/api-environment';

export class FleetStatsEnvironment extends ApiEnvironment {
  get graphqlUrl() {
    return `${this.baseUrl}/graphql/`;
  }

  get dashboardAccountStatsUrl() {
    return `${this.baseUrl}/api/dashboard/v1/accountStats`;
  }

  get dashboardAccountStatsAssetsUrl() {
    return `${this.baseUrl}/api/dashboard/v1/accountStats/assets`;
  }

  get dashboardAccountStatsTimeToActivateAssetUrl() {
    return `${this.baseUrl}/api/dashboard/v1/accountStats/timeToActivateAsset`;
  }

  get dashboardAccountStatsExportTTAAssetsUrl() {
    return `${this.baseUrl}/api/dashboard/v1/accountStats/exportTTAAssets`;
  }

  get dashboardVehicleStatsUnassignedVehicleGroupsUrl() {
    return `${this.baseUrl}/api/dashboard/v1/vehicleStats/unAssignedVehicleGroups`;
  }

  get dashboardVehicleStatsUnassignedConfigurationProfilesUrl() {
    return `${this.baseUrl}/api/dashboard/v1/vehicleStats/unAssignedConfigurationProfiles`;
  }

  get dashboardVehicleStatsUnassignedRoutingProfilesUrl() {
    return `${this.baseUrl}/api/dashboard/v1/vehicleStats/unAssignedRoutingProfiles`;
  }

  get dashboardRoutingProfileStatsUrl() {
    return `${this.baseUrl}/api/dashboard/v1/routingProfileStats`;
  }

  get dashboardAvoidFavorStatsUrl() {
    return `${this.baseUrl}/api/dashboard/v1/avoidFavorStats`;
  }

  get dashboardCustomPlacesStatsUrl() {
    return `${this.baseUrl}/api/dashboard/v1/customPlaceStats`;
  }

  get dashboardDeviceStatsDevicesWithOlderMapSetDataUrl() {
    return `${this.baseUrl}/api/dashboard/v1/deviceStats/devicesWithOlderMapSetData`;
  }

  get dashboardDeviceStatsDevicesMinutesSavedUsingTrafficDataUrl() {
    return `${this.baseUrl}/api/dashboard/v1/deviceStats/minutesSavedUsingTrafficData`;
  }

  get dashboardDeviceStatsWeatherEventsUrl() {
    return `${this.baseUrl}/api/dashboard/v1/deviceStats/weatherEvents`;
  }

  get dashboardDeviceStatsRolloverEventsUrl() {
    return `${this.baseUrl}/api/dashboard/v1/deviceStats/rolloverEvents`;
  }

  get dashboardDeviceStatsLocationDetails() {
    return `${this.baseUrl}/api/dashboard/v1/deviceStats/deviceLocationDetails`;
  }

  override resolve(environment: unknown) {
    return environment instanceof FleetStatsEnvironment ? environment : this;
  }
}

export const fleetStatsEnvironment = new FleetStatsEnvironment();
